var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSuccess = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 149,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M110 122c23.196 0 42-18.804 42-42s-18.804-42-42-42-42 18.804-42 42 18.804 42 42 42z",
    fill: "#26B77C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M93 80.092l12.895 13.09L131.077 68",
    stroke: "#fff",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.32 56.78l-3.66 3.29-.39-4.9L32 52.7l4.55-1.89L37.58 46l3.2 3.74 4.9-.52-2.57 4.2 2 4.5-4.79-1.14zM187.01 98.44l-3.01.39 1.52-2.63-1.31-2.75 2.98.64L189.4 92l.32 3.02 2.67 1.46-2.78 1.23-.56 2.99-2.04-2.26z",
    fill: "#8241AA",
    stroke: "#8241AA",
    strokeWidth: 0.46,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M180.47 38.72l-2.93.81 1.14-2.82-1.68-2.54 3.04.21 1.89-2.38.74 2.96 2.85 1.06-2.58 1.62-.14 3.03-2.33-1.95z",
    fill: "#C0C5CA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M128.11 10.22a5.11 5.11 0 100-10.22 5.11 5.11 0 000 10.22z",
    fill: "#8241AA",
    stroke: "#8241AA",
    strokeWidth: 0.46,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M53.11 149.22a5.11 5.11 0 100-10.22 5.11 5.11 0 000 10.22zM58.22 36.44a3.22 3.22 0 100-6.44 3.22 3.22 0 000 6.44z",
    fill: "#C0C5CA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M144.22 144.44a3.22 3.22 0 100-6.44 3.22 3.22 0 000 6.44z",
    fill: "#8241AA",
    stroke: "#8241AA",
    strokeWidth: 0.46,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M191.22 139.44a3.22 3.22 0 100-6.44 3.22 3.22 0 000 6.44z",
    fill: "#C0C5CA"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSuccess);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/success.e5dad6104d9c134e8c441c9cfc6a666a.svg";